import Objdict from "objdict"

import items from "@fae/source/data/games/ember/items.jsx"

chests = Objdict.convert(Object.keys(items).map((itemKey, index) => {
    const item = items[itemKey]
    if(item.isDraftable != true) return
    return {
        "key": item.key,
        "number": 110 + index,
        "equipment": {
            "items": {
                "0": {...item},
            }
        }
    }
}).filter((item) => !!item))

export default chests
